/**
 * Overlay toggle.
 */
export default function toggleOverlay( status ) {
	/**
	 * Status komt voort uit de functie parameter die meegegeven wordt (true/false).
	 */
	if ( status ) {
		/**
		 * Zorgen dat je zelfs on page scroll steeds de bovenkant van de filters ziet.
		 */
		document.querySelector( '.facets' ).scrollTop = 0;

		/**
		 * Overflow voorkomen op de rest van de content.
		 */
		document.body.style.overflow = 'hidden';

		/**
		 * Overlay toevoegen om de overige content te 'hiden'.
		 */
		const overlayDiv = document.createElement( 'div' );
		overlayDiv.classList.add( 'overlay' );
		document.body.appendChild( overlayDiv );
	} else {
		document.body.style.overflowY = 'scroll';

		if ( document.querySelector( '.overlay' ) ) {
			document.body.removeChild( document.querySelector( '.overlay' ) );
		}
	}
}
